export const GO_BACK = "GO_BACK"
export const GO_FORWARD = "GO_FORWARD"
export const SYNC_STARTING_URL_WITH_PAGE_ARRAY =
  "SYNC_STARTING_URL_WITH_PAGE_ARRAY"
